/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


// ----------------------------------

window.log = (...vars) => { // pour appeler : log(), à la place de console.log() !
    // if (!proto.$isProd) {
    if (vars[0] == 'clear') {
        console.clear();
        vars.splice(0, 1);
    } // vide la console si le mot clé "clear" est présent au début de log()
    // console.log(...vars)
    _.each(vars, (v, k) => {
        // console.log(k?`${k}`:'~~~', v)
        console.log(`${k ? k : '♥'}`, v)
    })
    // }
};
window.error = (...vars) => { // pour appeler : error(), à la place de console.error() !
    // if (!proto.$isProd) {
    console.error('ERROR :', ...vars)
    // }
};
